"use client";

import { useEffect, useRef, useState } from "react";
import { ArrowRight, Users } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DBouchageDeDrains() {
  const {
    ref: contentRef,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const [particles, setParticles] = useState<Array<{
    id: number;
    left: number;
    delay: number;
    duration: number;
    size: number;
  }>>([]);
  const sectionRef = useRef<HTMLElement>(null);
  useEffect(() => {
    const generated = Array.from({
      length: 24
    }, (_, i) => ({
      id: i,
      left: Math.random() * 100,
      delay: Math.random() * 8,
      duration: 12 + Math.random() * 10,
      size: 1 + Math.random() * 3
    }));
    setParticles(generated);
  }, []);
  const stats = [{
    label: "PRIX DE DÉPART",
    value: "275$"
  }, {
    label: "DISPONIBILITÉ",
    value: "24/7"
  }, {
    label: "ÉQUIPEMENT",
    value: "HAUTE PRESSION"
  }, {
    label: "GARANTIE",
    value: "SATISFACTION"
  }];
  return <section data-section-id="228" id="débouchage-de-drains" ref={sectionRef} className="relative bg-background text-foreground overflow-hidden min-h-[90vh] flex items-end">
      {}
      <div className="absolute inset-0 overflow-hidden">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694820/img/drain_cleaning_technician_montreal.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694820/img/drain_cleaning_technician_montreal.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694820/img/drain_cleaning_technician_montreal.png-wvc-sizes" alt="Technicien spécialisé en débouchage de drain avec équipement de pointe" loading="lazy" decoding="async" className="w-full h-full object-cover animate-[slowZoom_25s_ease-in-out_infinite_alternate]" />
        {}
        <div className="absolute inset-0" style={{
        background: "linear-gradient(90deg, hsla(222, 47%, 4%, 0.95) 0%, hsla(222, 47%, 6%, 0.85) 30%, hsla(222, 47%, 8%, 0.7) 60%, hsla(222, 47%, 12%, 0.5) 100%)"
      }} />
        <div className="absolute inset-0" style={{
        background: "linear-gradient(180deg, hsla(222, 47%, 6%, 0.6) 0%, transparent 30%, transparent 60%, hsla(222, 47%, 6%, 0.7) 100%)"
      }} />
      </div>

      {}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        {particles.map((p, i) => <span key={p.id} data-index={i} className="absolute rounded-lg bg-primary/30" style={{
        left: `${p.left}%`,
        bottom: `-10px`,
        width: `${p.size}px`,
        height: `${p.size}px`,
        animation: `floatUp ${p.duration}s linear ${p.delay}s infinite`,
        filter: "blur(0.5px)"
      }} />)}
      </div>

      {}
      <div className="absolute top-8 right-4 md:top-12 md:right-12 lg:right-20 pointer-events-none select-none" aria-hidden="true">
        <span className="font-serif font-light leading-none text-primary/[0.06]" style={{
        fontSize: "clamp(180px, 28vw, 380px)"
      }}>
          OT
        </span>
      </div>

      {}
      <div className="hidden lg:block absolute right-6 top-1/2 -translate-y-1/2 pointer-events-none z-10">
        <p className="font-mono text-[10px] tracking-[0.3em] text-foreground/50 uppercase whitespace-nowrap" style={{
        writingMode: "vertical-rl",
        transform: "rotate(180deg)"
      }}>
          MONTRÉAL &middot; LAVAL &middot; LONGUEUIL &middot; RIVE-NORD &middot; RIVE-SUD
        </p>
      </div>

      {}
      <div ref={contentRef} className={`relative z-10 w-full px-6 md:px-12 lg:px-20 xl:pl-[120px] xl:pr-20 pt-32 pb-16 md:pb-20 lg:pb-24 transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        {}
        <div className="flex items-center gap-3 mb-8 md:mb-10">
          <span className="block w-12 h-px bg-primary" />
          <p className="font-mono text-xs tracking-[0.25em] text-primary uppercase">
            [01] EXPERTISE &middot; DÉBOUCHAGE DE PRÉCISION
          </p>
        </div>

        {}
        <h1 className="font-default font-semibold text-foreground leading-[0.85] tracking-tighter mb-10 md:mb-12" style={{
        fontSize: "clamp(60px, 14vw, 160px)"
      }}>
          <span className="block">DRAINS</span>
          <span className="block pl-[0.5em]">BOUCHÉS</span>
          <span className="block italic text-primary">SOLUTIONS.</span>
        </h1>

        {}
        <p className="font-default text-base md:text-lg leading-relaxed text-foreground/80 max-w-[560px] mb-10 md:mb-12">
          Spécialistes en débouchage de drains et inspection par caméra à Montréal. 
          Une approche chirurgicale pour vos conduits obstrués, utilisant les technologies 
          les plus avancées du marché. Intervention rapide, résultats garantis.
        </p>

        {}
        <div className="mb-10 md:mb-12 max-w-3xl">
          <div className="flex flex-wrap items-stretch gap-y-4 border-t border-b border-border/40 py-5">
            {stats.map((stat, i) => <div key={stat.label} data-index={i} className={`flex-1 min-w-[140px] px-4 md:px-5 ${i !== 0 ? "md:border-l border-border/40" : ""}`}>
                <p className="font-mono text-[10px] tracking-[0.2em] text-foreground/50 uppercase mb-1.5">
                  {stat.label}
                </p>
                <p className="font-mono text-sm md:text-base font-medium text-foreground tracking-wider">
                  {stat.value}
                </p>
              </div>)}
          </div>
        </div>

        {}
        <div className="flex flex-wrap items-center gap-4">
          <Button asChild size="lg" className="h-14 px-8 bg-secondary text-secondary-foreground hover:bg-secondary/90 font-mono text-xs tracking-[0.2em] uppercase rounded-md shadow-lg">
            <Link to="tel:438-367-8309">
              Appeler Maintenant
              <ArrowRight className="ml-1 size-4" />
            </Link>
          </Button>
          <Button asChild variant="outline" size="lg" className="h-14 px-8 bg-transparent border border-foreground/30 text-foreground hover:bg-foreground/5 hover:text-foreground font-mono text-xs tracking-[0.2em] uppercase rounded-md">
            <Link to="/CameraInspectionPage">
              <Users className="mr-1 size-4" />
              Inspection Caméra
            </Link>
          </Button>
        </div>
      </div>

      {}
      <style>{`
        @keyframes slowZoom {
          0% { transform: scale(1); }
          100% { transform: scale(1.12); }
        }
        @keyframes floatUp {
          0% {
            transform: translateY(0) translateX(0);
            opacity: 0;
          }
          15% {
            opacity: 0.6;
          }
          85% {
            opacity: 0.4;
          }
          100% {
            transform: translateY(-105vh) translateX(20px);
            opacity: 0;
          }
        }
      `}</style>
    </section>;
}